import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { DialogTitle, DialogContent, DialogActions, Button as MUIButton } from '@mui/material';
import dp from '../../providers/AppDataProvider';
import { Resources } from '../resource';
import UpgradeAgentForm from './UpgradeAgentForm';
import { PermissionGuard } from 'src/routes/components/permission-guard';

type Row = {
  userId: string;
  userLevel?: string;
  [key: string]: any;
};

const UpgradeAgentLevel = ({
  row,
  open,
  onClose,
}: {
  row: Row;
  open?: boolean;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const onSubmit = async (values: any) => {
    const userId = row?.userId ?? values?.userId;
    if (!userId) {
      notify('Missing userId', { type: 'warning' });
      return;
    }
    const payload = {
      userId,
      targetLevelId: Number(values.targetLevelId || 0),
      reason: values.reason,
      effectiveDate: values.effectiveDate,
      upgradedBy: values.upgradedBy,
    };

    await dp.update(Resources.agentInfo, {
      id: row.userId,
      data: payload,
      previousData: row,
    });

    notify('module.agentInfo.UserSuccessfullyUpgraded', { type: 'success' });
    refresh();
    onClose();
  };

  if (open === false) return null;

  const defaultValues = {
    userId: row.userId,
    // userLevel: row.userLevel ?? '',
    userLevel: row?.user?.agentLevelId ?? '',
    agentLevelId: row?.user?.agentLevelId,
  };

  return (
    <Form disableInvalidFormNotification defaultValues={defaultValues} onSubmit={onSubmit}>
      <DialogTitle>{t('module.agentInfo.upgradeAgentInfo')}</DialogTitle>

      <DialogContent>
        <UpgradeAgentForm isCreate={false} />
      </DialogContent>

      <DialogActions>
        <MUIButton variant="outlined" onClick={onClose}>
          {t('actions.cancel')}
        </MUIButton>
        <PermissionGuard
          anyOf={[
            { resource: 'agent-info', action: 'upgrade' },
            { resource: 'agent-info', action: 'upgrade-plus' },
          ]}
          fallback={<></>}
        loadingFallback={<></>}
        >
          <SaveButton />
        </PermissionGuard>
      </DialogActions>
    </Form>
  );
};

export default UpgradeAgentLevel;
